import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { BaseService } from "../base.service";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-add-to-playlist",
  templateUrl: "./add-to-playlist.component.html",
  styleUrls: ["./add-to-playlist.component.css"],
})
export class AddToPlaylistComponent implements OnInit {
  playListData: any = [];
  isLogin: boolean;
  model: any = {};
  constructor(
    public service: BaseService,
    public translate: TranslateService,
    public dialogRef: MatDialogRef<AddToPlaylistComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.getPlayList();
    if (localStorage.getItem(environment.localStorageKey)) {
      this.isLogin = true;
    }
  }
  getPlayList() {
    const data = {
      limit: 10,
      offset: 0,
      type: "album",
    };
    this.service.playList(data).subscribe(
      (res) => {
        this.playListData = res.results;
      },
      (err: any) => {}
    );
  }

  createPlayList(data: any) {
    if (data) {
      const params = {
        playlist_id: data.public_id,
        song_id: this.data.public_id,
      };
      this.service.addSongtoPlyalist(params).subscribe(
        (res) => {
          this.dialogRef.close();
          this.toastr.success(res.message, "Success!", {
            closeButton: true,
          });
        },
        (err) => {
          this.toastr.error(err.error.message, "OOPS!", {
            closeButton: true,
          });
        }
      );
    } else {
      if (this.model.name) {
        this.service.createPlayList(this.model).subscribe(
          (res) => {
            const params = {
              playlist_id: res.public_id,
              song_id: this.data.public_id,
            };
            if (this.data !== "create") {
              this.service.addSongtoPlyalist(params).subscribe(
                (res) => {
                  this.dialogRef.close();
                  this.toastr.success(res.message, "Success!", {
                    closeButton: true,
                  });
                },
                (err) => {
                  this.toastr.error(err.error.message, "OOPS!", {
                    closeButton: true,
                  });
                }
              );
            } else {
              this.dialogRef.close();
              this.toastr.success(res.message, "Success!", {
                closeButton: true,
              });
            }
          },
          (err) => {
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
          }
        );
      }
    }
  }
  close() {
    this.dialogRef.close();
  }
}
